import {
  maryvilleProgramsTestimonialsDefaults,
  UNCKennanFlaglerMbaTestimonialsDefaults,
  nyuSteinhardtMentalHealthCounselingTestimonialsDefaults,
  ucBerkeleyCybersecurityTestimonialsDefaults,
  ucBerkeleyMidsTestimonialsDefaults,
  londonSchoolDefaults,
} from "./learnerTestimonialsDefaults";
import { DegreeDetailPageV5_2Default } from "./learnerTestimonialsDefaults";

export const UUID_TO_LEARNER_TESTIMONIALS_MAPPING = {
  // UNC Kenan-Flagler's MBA online
  "1be98dfc-6b32-4f4c-8beb-02a2b1ef9183":
    UNCKennanFlaglerMbaTestimonialsDefaults,

  // UC Berkeley’s Master of Information and Data Science (MIDS) online
  "58331700-1a02-4abe-a858-4ebe83200d15": ucBerkeleyMidsTestimonialsDefaults,

  // UC Berkeley Master's in Cybersecurity online
  "5c002189-0866-4b10-807e-bcf093346dc0":
    ucBerkeleyCybersecurityTestimonialsDefaults,

  // NYU Steinhardt Online Mental Health Counseling Master’s
  "32343235-d926-418d-b803-a8fa04ba6888":
    nyuSteinhardtMentalHealthCounselingTestimonialsDefaults,

  // Maryville programs

  // Masters:
  "fefd092a-c8e7-4cbd-9c5b-ba0d1e9ee9a2": maryvilleProgramsTestimonialsDefaults,
  "fae3cd5c-3a1e-407d-ad96-2dce117d49c4": maryvilleProgramsTestimonialsDefaults,
  "ee60cf8f-3b6c-476f-94c1-1a16c8f50c48": maryvilleProgramsTestimonialsDefaults,
  "de971614-e9f1-4dc5-9081-5dec52d5ac4e": maryvilleProgramsTestimonialsDefaults,
  "b17c2c97-625c-4c7a-a4b4-78845113a082": maryvilleProgramsTestimonialsDefaults,
  "518b3b7e-f773-4b11-8427-4343b53cd1ae": maryvilleProgramsTestimonialsDefaults,
  "3e528fb0-b16d-40fa-947a-8f224bc173b1": maryvilleProgramsTestimonialsDefaults,
  "333b8b06-ca26-4d73-853b-ef9ceee271ac": maryvilleProgramsTestimonialsDefaults,
  "0fff466d-8d0a-418a-af92-f2058e121ef3": maryvilleProgramsTestimonialsDefaults,
  "0ecf2868-e7b5-4ede-8077-334d0bc4ffe8": maryvilleProgramsTestimonialsDefaults,

  // Bachelors:
  "f55b0dd1-04fe-45bb-b3f6-1c0984955a6e": maryvilleProgramsTestimonialsDefaults,
  "e86df75d-27f4-4a80-a2d0-8c14c4edf63f": maryvilleProgramsTestimonialsDefaults,
  "e70a3e9b-eae5-447d-bbd6-5e786ea75cef": maryvilleProgramsTestimonialsDefaults,
  "e655636b-a562-4022-afad-c93046f266d8": maryvilleProgramsTestimonialsDefaults,
  "e599eac8-5468-4ceb-a546-c05f928f4920": maryvilleProgramsTestimonialsDefaults,
  "e3633b6d-8b23-4a19-8b92-b0a623ffc5f8": maryvilleProgramsTestimonialsDefaults,
  "e19fefa8-ab16-4338-9790-73e16e6a10f8": maryvilleProgramsTestimonialsDefaults,
  "e045a0f4-aa9e-4ba6-9d5a-6d55bc1cd1f9": maryvilleProgramsTestimonialsDefaults,
  "da3a0dc4-f697-48fd-bc7d-44c208608dd5": maryvilleProgramsTestimonialsDefaults,
  "d2d8568d-4264-48ce-9b0d-76fd1412604b": maryvilleProgramsTestimonialsDefaults,
  "cdca852a-c6e3-4263-981a-f464a37f3a9e": maryvilleProgramsTestimonialsDefaults,
  "c3abf25d-a907-4e3c-b940-802d5e1744bd": maryvilleProgramsTestimonialsDefaults,
  "b6223778-8769-407a-85e3-3f167d170d24": maryvilleProgramsTestimonialsDefaults,
  "b02e0669-8a7c-4c2b-982d-1d4f3be0f739": maryvilleProgramsTestimonialsDefaults,
  "afdd845b-71fe-4aca-9148-d62945e4b65b": maryvilleProgramsTestimonialsDefaults,
  "a6c8dedd-f06a-47f0-8d3d-2268a6f1ac9a": maryvilleProgramsTestimonialsDefaults,
  "993c1ddd-d2c9-4fb5-8def-a9fd84df8ffd": maryvilleProgramsTestimonialsDefaults,
  "97fab0cf-b40d-4771-a255-1805ec06b3c2": maryvilleProgramsTestimonialsDefaults,
  "90cefce3-c45d-41e8-acab-7231a5d80076": maryvilleProgramsTestimonialsDefaults,
  "6df32a36-6b15-40eb-8a6c-c8bb6146e390": maryvilleProgramsTestimonialsDefaults,
  "6d2bfd17-1e92-40e4-89eb-7cc1b24a6f44": maryvilleProgramsTestimonialsDefaults,
  "4d1f7feb-cad6-41f2-91b6-5fabe6d93da5": maryvilleProgramsTestimonialsDefaults,
  "3ff52388-4b77-48e3-bfc0-c80b19c1ba93": maryvilleProgramsTestimonialsDefaults,
  "1ff33eeb-a989-4a8a-8f5e-f3f29ca27dbe": maryvilleProgramsTestimonialsDefaults,
  "1a0169cf-0f08-480a-ad38-131f447882c3": maryvilleProgramsTestimonialsDefaults,
  "171cd35c-9585-4311-b59f-c0b9216e3445": maryvilleProgramsTestimonialsDefaults,
  "075eba3a-3c15-4f32-aae0-99623723b15b": maryvilleProgramsTestimonialsDefaults,
  "008edcc2-6c7d-4f35-a103-1470128712fd": maryvilleProgramsTestimonialsDefaults,

  // London school of economics and political maryvilleProgramsTestimonialsDefaults, degrees:
  "f9414209-c0ac-4572-bb46-2dde155f3a22": londonSchoolDefaults,
  "c106927f-09cc-4b9a-9f8c-c757db45d92a": londonSchoolDefaults,
  "8667372e-53eb-44a9-9dd0-c494e72d7db1": londonSchoolDefaults,
  "6b380029-6a1e-4236-90f2-cccc57990d1a": londonSchoolDefaults,
  "5e15f5aa-8a0a-4362-833d-1c9875e1ebad": londonSchoolDefaults,
  "2fca092d-dfdf-4389-a68f-6023618f63db": londonSchoolDefaults,
  "183bd207-c328-45f7-a80c-959fd358ea78": londonSchoolDefaults,
  "159d1753-d974-4b5b-b657-516805797753": londonSchoolDefaults,
  "123f9327-bfef-459f-8bf2-c53277aa58f8": londonSchoolDefaults,
} as Record<string, DegreeDetailPageV5_2Default>;

export function getDegreeDetailV5_2Defaults(
  uuid: string,
): DegreeDetailPageV5_2Default | undefined {
  return UUID_TO_LEARNER_TESTIMONIALS_MAPPING[uuid];
}

type MaryvilleChromeTranslator = {
  (key: MaryvilleChromeKey): string;
};

type MaryvilleChromeKey =
  | "maryvilleNoTestScoresLabel"
  | "maryvilleNoTestScoresValue"
  | "maryvilleTransferCreditsLabel"
  | "maryvilleTransferCreditsValue"
  | "maryvilleOnlineGradStudentsLabel"
  | "maryvilleStatsSectionTitle"
  | "maryvilleAccreditationTitle"
  | "maryvilleAccreditationDescription";

export function localizeMaryvilleV5_2Chrome(
  defaults: DegreeDetailPageV5_2Default,
  t: MaryvilleChromeTranslator,
): DegreeDetailPageV5_2Default {
  return {
    ...defaults,
    stats: [
      {
        label: t("maryvilleNoTestScoresLabel"),
        value: t("maryvilleNoTestScoresValue"),
      },
      {
        label: t("maryvilleTransferCreditsLabel"),
        value: t("maryvilleTransferCreditsValue"),
      },
      {
        label: t("maryvilleOnlineGradStudentsLabel"),
        value: defaults.stats[2]?.value ?? "",
      },
    ],
    statsSectionTitle: t("maryvilleStatsSectionTitle"),
    accreditation: {
      ...defaults.accreditation,
      title: t("maryvilleAccreditationTitle"),
      description: t("maryvilleAccreditationDescription"),
    },
  };
}

export function isMaryvilleV5_2Defaults(
  defaults: DegreeDetailPageV5_2Default,
): boolean {
  return defaults === maryvilleProgramsTestimonialsDefaults;
}
